module.exports = __webpack_public_path__ + "assets/img/202109-6.5c21473d.png";